










import { Component, Vue } from "vue-property-decorator"
import Header from "@/components/Header.vue"

@Component({
  components: {
    Header,
  },
  head: {
    title: {
      inner: "ログイン",
    },
    meta() {
      return [{ name: "robots", content: "noindex, nofollow" }]
    },
  },
})
export default class LoginLayout extends Vue {}
